module.exports = __webpack_public_path__ + "img/no-2.2bd655fb.svg";